 $(function(){

  var scrollend = $('footer').offset().top ; //ページ上部からの距離を取得
  var distance = 0;
  var windowHeight = $(window).innerHeight();
  var windowWidth = $(window).innerWidth();

  if(windowWidth > 750){
    $(document).scroll(function(){
      distance = $(this).scrollTop(); //スクロールした距離を取得
      if (scrollend <= (distance + windowHeight)) {
        $('#fixed_menu').fadeOut();
      } else{
        $('#fixed_menu').fadeIn();
      }
  });
  }
$(".openbtn1").click(function () {//ボタンがクリックされたら
  $(".openbtn1").toggleClass('non_visible');//ボタン自身に activeクラスを付与し
  $(".openbtn3").toggleClass('non_visible');//ボタン自身に activeクラスを付与し  
  $("#g-nav").toggleClass('panelactive');//ナビゲーションにpanelactiveクラスを付与
});
   
$(".openbtn3").click(function () {//ボタンがクリックされたら
  $(".openbtn1").toggleClass('non_visible');//ボタン自身に activeクラスを付与し
  $(".openbtn3").toggleClass('non_visible');//ボタン自身に activeクラスを付与し  
  $("#g-nav").removeClass('panelactive');//ナビゲーションにpanelactiveクラスを付与
});

$("#g-nav a").click(function () {//ナビゲーションのリンクがクリックされたら
    $(".openbtn1").removeClass('non_visible');//ボタン自身に activeクラスを付与し
    $(".openbtn3").addClass('non_visible');//ボタン自身に activeクラスを付与し  
    $("#g-nav").removeClass('panelactive');//ナビゲーションのpanelactiveクラスも除去
});

 });

